<template>
  <div v-loading="isLoading">
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <rest-form-item
        :label="$t('Integrations_Salesforce_Field_AuthBaseUrl')"
        prop="params.authBaseUrl"
      >
        <el-input
          v-model="model.params.authBaseUrl"
          :placeholder="$t('Integrations_Salesforce_Field_AuthBaseUrl')"
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Salesforce_Field_RestBaseUrl')"
        prop="params.restBaseUrl"
      >
        <el-input
          v-model="model.params.restBaseUrl"
          :placeholder="$t('Integrations_Salesforce_Field_RestBaseUrl')"
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Salesforce_Field_SoapBaseUrl')"
        prop="params.soapBaseUrl"
      >
        <el-input
          v-model="model.params.soapBaseUrl"
          :placeholder="$t('Integrations_Salesforce_Field_SoapBaseUrl')"
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Salesforce_Field_ClientId')"
        prop="params.clientId"
      >
        <el-input
          v-model="model.params.clientId"
          :placeholder="$t('Integrations_Salesforce_Field_ClientId')"
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Salesforce_Field_ClientSecret')"
        prop="params.clientSecret"
      >
        <el-input
          v-model="model.params.clientSecret"
          :placeholder="$t('Integrations_Salesforce_Field_ClientSecret')"
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Salesforce_Field_ClientMid')"
        prop="params.clientMid"
      >
        <el-input
          v-model="model.params.clientMid"
          :placeholder="$t('Integrations_Salesforce_Field_ClientMid')"
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Salesforce_Field_ActivityKey')"
        :hint="
          $t('Integrations_Salesforce_Text_EndpointsInfo') + `: ` + apiEndpoint
        "
        prop="params.activityKey"
      >
        <el-input
          v-model="model.params.activityKey"
          :placeholder="$t('Integrations_Salesforce_Field_ActivityKey')"
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Salesforce_Field_JwtToken')"
        prop="params.jwt_token"
      >
        <el-input
          v-model="model.params.jwt_token"
          :placeholder="$t('Integrations_Salesforce_Field_JwtToken')"
        />
      </rest-form-item>
    </form-section>
    <form-section :title="$t('Integrations_Settings_ContactMapping')">
      <el-table :stripe="true" :data="[1]">
        <el-table-column
          :label="$t('Integrations_Settings_ContactMapping_IdentifierCol')"
        >
          <template>
            {{ $t('Integrations_Settings_ContactMapping_IdentifierColValue') }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('Integrations_Settings_ContactMapping_MapCol')"
        >
          <template>
            <el-input
              class="map-input"
              v-model="model.params.contact_id"
              readonly
              v-if="isUpdate"
            ></el-input>
            <el-select
              v-model="model.params.contact_id"
              :readonly="true"
              v-else
            >
              <el-option
                v-for="option in contactIdOptions"
                :value="option"
                :key="option"
                >{{ option }}</el-option
              >
            </el-select>
          </template>
        </el-table-column>
      </el-table>
    </form-section>
  </div>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import { $hasFeature } from '@/core/utils/VueAcl'
export default {
  name: 'ConnectionStep',
  components: { RestFormItem, FormSection },
  props: {
    model: {
      type: Object
    },
    schemaFetchingAllowed: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    this.$set(this.model, 'fixedMappings', this.fixedMappings)
    if (!this.model.params.hasOwnProperty('contact_id')) {
      this.$set(this.model.params, 'contact_id', 'user_id')
    }
  },
  data() {
    return {
      isLoading: false,
      fixedMappings: {}
    }
  },
  methods: {
    getSchema() {
      this.isLoading = true
      this.$set(this.model.params, 'mapping', [])
      RestApi(
        projectEndpoint({
          method: 'post',
          url: 'integrations/salesforce/get-attributes-list',
          data: {
            ...this.model.params
          }
        })
      )
        .then(({ data }) => {
          this.model.params.mapping = [
            {
              name: 'ContactKey',
              dataExtensionName: 'Contact',
              attributeName: 'Key',
              attribute: 'user_id',
              sample: '123, a2, 3b',
              readOnly: true
            },
            ...data.columns
          ]
          this.updateCols()
          this.isLoading = false
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error',
            dangerouslyUseHTMLString: true
          })
          this.isLoading = false
        })
    },

    updateCols() {
      const filterableAttributes = [
        'user_id',
        'email',
        'mobile_number',
        'whatsapp_number',
        'language',
        'timezone',
        'email_addressable',
        'email_subscription',
        'sms_addressable',
        'sms_subscription'
      ]
      this.model.params.mapping.forEach(col => {
        if (this.fixedMappings.hasOwnProperty(col.name)) {
          this.$set(col, 'attribute', this.fixedMappings[col.name])
        }
        if (
          filterableAttributes.findIndex(
            e => e.toUpperCase() === col.name.toUpperCase()
          ) >= 0
        ) {
          let attrName = filterableAttributes.find(
            e => e.toUpperCase() === col.name.toUpperCase()
          )
          if (!this.isEdit) {
            this.$set(col, 'attribute', attrName)
          }
        }
      })
    }
  },
  computed: {
    isUpdate() {
      return this.$route.query.hasOwnProperty('id')
    },
    contactIdOptions() {
      let options = ['user_id']
      if ($hasFeature('customerIdEnabled')) {
        options.push('customer_id')
      }
      return options
    },
    apiEndpoint() {
      let apiEndpoint = this.$store.state.app.domains.api
      return `https://${apiEndpoint}/integrations/salesforce`
    }
  },
  watch: {
    'model.params.contact_id': {
      handler(val) {
        if (this.model.params.hasOwnProperty('mapping')) {
          const fields = ['user_id', 'customer_id']
          fields.forEach(attr => {
            if (val === attr) {
              this.model.params.mapping.forEach(m => {
                if (m.hasOwnProperty('attribute') && m.attribute === attr) {
                  delete m.attribute
                }
              })
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.map-input {
  max-width: 227px;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/salesforce/ConnectionStep.vue